/* src/app/dialogs/group-finder/group-finder.component.css */
.summary {
  width: 100%;
  border-radius: 5px;
  padding: 20px;
  font-family:
    Roboto,
    "Helvetica Neue",
    sans-serif;
  margin-bottom: 10px;
}
.warning {
  background-color: yellow;
}
.match {
  background-color: lightgreen;
}
.nomatch,
.article-blocked,
.relation-blocked {
  background-color: orangered;
}
/*# sourceMappingURL=group-finder.component-ZBM6KX45.css.map */
